export const loadGoogleTranslate = () => {
  // If script not already present, inject it
  if (!document.getElementById('google-translate-script')) {
    const addScript = document.createElement('script');
    addScript.id = 'google-translate-script';
    addScript.src =
      '//translate.google.com/translate_a/element.js?cb=initGoogleTranslate';
    document.body.appendChild(addScript);
  }
};

export const initGoogleTranslate = () => {
  if (window.google && window.google.translate) {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: 'ka',
        autoDisplay: false,
        includedLanguages: 'en,ka',
      },
      'google_translate_element'
    );

    // Check if this is the first load
    const isFirstLoad = !sessionStorage.getItem('hasReloaded');

    if (isFirstLoad) {
      sessionStorage.setItem('hasReloaded', 'true');
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      // Set initial language immediately and keep trying until successful
      const forceGeorgian = () => {
        const selectEl = document.querySelector('.goog-te-combo');
        if (selectEl) {
          selectEl.value = 'ka';
          const event = new Event('change', { bubbles: true });
          selectEl.dispatchEvent(event);
          return true;
        }
        return false;
      };

      // Try immediately
      forceGeorgian();

      // Keep trying for a few seconds to ensure it sticks
      let attempts = 0;
      const maxAttempts = 20;
      const interval = setInterval(() => {
        if (forceGeorgian() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 100);
    }
  }
};

// Expose init to global so Google can call it
window.initGoogleTranslate = initGoogleTranslate;

export const changeGoogleLanguage = (lang) => {
  const selectEl = document.querySelector('.goog-te-combo');
  if (selectEl) {
    selectEl.value = lang;
    const event = new Event('change', { bubbles: true });
    selectEl.dispatchEvent(event);

    // If switching to Georgian, try to restore original content
    if (lang === 'ka') {
      const iframe = document.querySelector('iframe.goog-te-menu-frame');
      if (iframe) {
        try {
          const restoreButton =
            iframe.contentWindow.document.querySelector('div#\\:0\\.restore');
          if (restoreButton) {
            restoreButton.click();
          }
        } catch (e) {
          console.log('Could not restore to Georgian:', e);
        }
      }
    }
  }
};
